/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module UpdateModule */

import {
    Component,
    Input,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import { SystemConfig } from 'ajs/modules/system/factories/system-config.item.factory';
import * as StateNames from 'state-names';

import { UpgradeProfileItem } from 'ng/modules/items/factories/upgrade-profile.item.factory';

import { StateService } from '@uirouter/core';
import * as l10n from './update-page.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 * Component for Update Page.
 * @author Dhanashree Tilak, Vinay Jadhav
 */
@Component({
    selector: 'update-page',
    templateUrl: './update-page.component.html',
})
export class UpdatePageComponent {
    @Input('loadedSystemConfigService')
    public systemConfig: SystemConfig;

    @Input('resolveUpgradeProfile')
    public upgradeProfileItem: UpgradeProfileItem;

    public readonly l10nKeys = l10nKeys;

    public readonly stateNames = StateNames;

    /**
     * Flag to indicate that system tab is active.
     */
    public isSystemTabActive = true;

    constructor(
        l10nService: L10nService,
        private readonly $state: StateService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * UpdateProfile Edit button click handler.
     */
    public editUpgradeProfile(): void {
        this.upgradeProfileItem.edit();
    }
}
